<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card raised>
          <v-card-title class="display-1">Product Summary</v-card-title>
          <div class="product-title">
            <v-progress-circular
              indeterminate
              color="primary"
              v-show="loading"
            ></v-progress-circular>
            <div v-show="!loading">
              <div class="product-image">
                <img v-if="!loading" :src="getProductThumbnail(product)" alt=""
                    @error.once="thumbnailFallback($event, product)">
              </div>
              <div class="title mb-2" v-if="product.id !== product.sku">{{ product.sku }}</div>
              <div class="title">{{ product.name_zh_hk }}</div>
              <span class="grey--text">{{ product.size }}</span>
            </div>
          </div>
          <v-card-text
            v-html="product.description_zh_hk"
          ></v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card raised>
          <v-card-title class="display-1">Sales (Past 6 months)</v-card-title>
          <v-data-table
            :loading="loading"
            :items="product.sales_monthly"
            :headers="salesHeaders"
            :options="salesPagination"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ getPeriodString(item.from, item.to) }}</td>
                <td>{{ item.count || '-' }}</td>
                <td>{{ item.amount ? item.amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : '-' }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col xs12>
        <v-card raised>
          <v-card-title class="display-1">Top 5 Locations (Past 30 days)</v-card-title>
          <v-data-table
            :loading="loading"
            :items="locations"
            :headers="locationHeaders"
            :options="locationPagination"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.sale.count || '-' }}</td>
                <td>{{ item.sale.amount ? item.sale.amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') :
                  '-' }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import productMixin from '@/mixins/product'
  import datetimeMixin from '@/mixins/datetime'

  export default {
    mixins: [ productMixin, datetimeMixin ],

    props: {
      loading: Boolean,
      product: Object
    },

    data () {
      return {
        salesPagination: {
          sortBy: 'to',
          descending: true
        },

        salesHeaders: [
          {
            text: 'Date',
            value: 'to',
            align: 'left',
            sortable: false
          },
          {
            text: 'Number of Sales',
            value: 'count',
            align: 'left',
            sortable: false
          },
          {
            text: 'Total Amount',
            value: 'amount',
            align: 'left',
            sortable: false
          }
        ],

        locationPagination: {
          sortBy: 'sale.amount',
          descending: true
        },

        locationHeaders: [
          {
            text: 'Location',
            value: 'name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Number of Sales',
            value: 'sale.count',
            align: 'left',
            sortable: false
          },
          {
            text: 'Total Amount',
            value: 'sale.amount',
            align: 'left',
            sortable: false
          }
        ]
      }
    },

    computed: {
      locations () {
        return this.product.locations
          ? this.product.locations.slice(0, 5)
          : []
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .product-title
    text-align center

  .product-image
    width 170px
    height @width
    margin 0 auto 16px

    img
      width 100%
      height 100%
      object-fit contain
</style>



// WEBPACK FOOTER //
// src/components/Common/Product/Summary.vue